const MY_MUSIC_SUB_TYPE = {
  ALBUM: 'album',
  ARTIST: 'artist',
  TRACK: 'song',
};

export default MY_MUSIC_SUB_TYPE;
